/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_EmptyInputs */

const th_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีทีม`)
};

const en_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No teams yet.`)
};

const ja_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームがまだありません。`)
};

const zh_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无球队。`)
};

const es_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay equipos.`)
};

const pt_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum time ainda.`)
};

const id_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada tim.`)
};

const fr_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune équipe pour l’instant.`)
};

const tl_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang team.`)
};

const vi_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có đội nào.`)
};

const ko_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 팀이 없습니다.`)
};

const de_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Teams.`)
};

const ru_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команд пока нет.`)
};

const tr_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz takım yok.`)
};

const it_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna squadra.`)
};

const pl_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie ma jeszcze drużyn.`)
};

const uk_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команд поки немає.`)
};

const hi_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी कोई टीम नहीं।`)
};

const ar_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد فرق بعد.`)
};

const ms_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pasukan.`)
};

const bn_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও কোনও দল নেই।`)
};

const zh_tw2_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無球隊。`)
};

const zh_hk2_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無球隊。`)
};

const ur_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کوئی ٹیم نہیں۔`)
};

const fa_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز تیمی نیست.`)
};

const sw_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna timu bado.`)
};

const nl_teams_empty = /** @type {(inputs: Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen teams.`)
};

/**
* | output |
* | --- |
* | "No teams yet." |
*
* @param {Teams_EmptyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const teams_empty = /** @type {((inputs?: Teams_EmptyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_EmptyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_teams_empty(inputs)
	if (locale === "ja") return ja_teams_empty(inputs)
	if (locale === "zh") return zh_teams_empty(inputs)
	if (locale === "es") return es_teams_empty(inputs)
	if (locale === "pt") return pt_teams_empty(inputs)
	if (locale === "id") return id_teams_empty(inputs)
	if (locale === "fr") return fr_teams_empty(inputs)
	if (locale === "tl") return tl_teams_empty(inputs)
	if (locale === "vi") return vi_teams_empty(inputs)
	if (locale === "ko") return ko_teams_empty(inputs)
	if (locale === "de") return de_teams_empty(inputs)
	if (locale === "ru") return ru_teams_empty(inputs)
	if (locale === "tr") return tr_teams_empty(inputs)
	if (locale === "it") return it_teams_empty(inputs)
	if (locale === "pl") return pl_teams_empty(inputs)
	if (locale === "uk") return uk_teams_empty(inputs)
	if (locale === "hi") return hi_teams_empty(inputs)
	if (locale === "ar") return ar_teams_empty(inputs)
	if (locale === "ms") return ms_teams_empty(inputs)
	if (locale === "bn") return bn_teams_empty(inputs)
	if (locale === "zh-TW") return zh_tw2_teams_empty(inputs)
	if (locale === "zh-HK") return zh_hk2_teams_empty(inputs)
	if (locale === "ur") return ur_teams_empty(inputs)
	if (locale === "fa") return fa_teams_empty(inputs)
	if (locale === "sw") return sw_teams_empty(inputs)
	if (locale === "nl") return nl_teams_empty(inputs)
	return en_teams_empty(inputs)
});